import { useEffect, useState } from "react";
import { NavPerson } from "../components/navTop";
import { HeaderBanner } from "../components/banners";
import PageFooter from "../components/footer";
import StaffInformation from "../components/staff_components";
import { useParams } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

export default function App() {
    const { page } = useParams();
    const [navMenuPerson, setNavMenuPerson] = useState([]);
    const [navMenuItem, setNavMenuItem] = useState([]);
    // const [isLoading, setIsLoading] = useState(false);

    async function fetchNavMenuItem() {
      await axios
          .get(`${apiUrl}nav/index.json`)
          .then((res) => {
              setNavMenuItem(res.data);
          })
          .catch((error) => {
              console.error(`nav axios err: ${error}`);
          });
  }

    async function fetchNavMenuPerson() {
      await axios
          .get(`${apiUrl}nav/staff.json`)
          .then((res) => {
              setNavMenuPerson(res.data);
          })
          .catch((error) => {
              console.error(`nav axios err: ${error}`);
          });
  }

    useEffect(() => {
        fetchNavMenuPerson();
        fetchNavMenuItem();

        AOS.init();
        // eslint-disable-next-line
    }, []);

    return (
        <>
            {/* <h1>arch 2024 version presented by React.</h1> */}
            <div id="contentHolder">
                <HeaderBanner />
                <NavPerson navMenuPerson={navMenuPerson} active={page} />
                <section id="mainContent" style={{ marginTop: "80px" }}>
                    {/* {console.log("page params: " , page)} */}
                    <StaffInformation boardName={page} />
                </section>
            </div>
            {navMenuItem && <PageFooter navMenuItem={navMenuItem} />}
        </>
    );
}
